import { render, staticRenderFns } from "./ThePreviewMenu.vue?vue&type=template&id=64d7345e&scoped=true&"
import script from "./ThePreviewMenu.vue?vue&type=script&lang=ts&"
export * from "./ThePreviewMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ThePreviewMenu.vue?vue&type=style&index=0&id=64d7345e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d7345e",
  null
  
)

export default component.exports